export default __webpack_public_path__ + "static/media/deleteAccountStep2.09b006a1.png";